export default __webpack_public_path__ + "media/images/new_year/header_1920x1080_2-06f74d5f5d821a9e5141639688e725d9.jpg";